import React, { useEffect, useState, useMemo } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import {
  useAddPaymentMutation,
  useAssignTechnicianMutation,
  useCreateHistoryMutation,
  useCreateVehicleMutation,
  useUpdateVehicleMutation,
  useGetVehicleQuery,
  useHistoryQuery,
  useOrderByIdQuery,
  usePaymentByIdQuery,
  useStatusQuery,
  useTechniciansQuery,
  useUpdateStatusMutation,
  useRequestStockMutation,
  // Off-days API hooks
  useGetOffDaysQuery,
  useGetOffDaysHistoryQuery,
  useProcessOffDaysMutation,
  useUpdateOrderStatusWithOffDaysMutation,
} from "../../../Store/Apis/bookingApi";
import {
  updateReservation,
  checkRoomAvailability,
  fetchRoomTypes,
  assignRoomType,
} from "../../../Store/Apis/ReservationApi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../Components/Loader/Loader";
import Error from "../../../Components/Error/Error";
import toast from "react-hot-toast";
import AddPaymentForm from "../../../Components/AddPaymentForm/AddPaymentForm";
import FormatDateTime from "../../../Hooks/FormatDateTime";
import { useSelector } from "react-redux";
import { isPermissionGranted } from "../../../Hooks/permissionsMiddleware";
import AddEditVehicleDetails from "../../../Components/AddEditVehicleDetails/AddEditVehicleDetails";
import EditQuotationForm from "../../../Components/EditQuotationForm/EditQuotationForm";
import { useTaxPercentageQuery } from "../../../Store/Apis/toolsApi";
import formatDate from "../../../Hooks/formatDate";
import { useRolesQuery } from "../../../Store/Apis/rolePermissionApi";
import { useAllExistingUsersQuery } from "../../../Store/Apis/manageUserApi";
import { useCreateSupplierInvoiceMutation } from "../../../Store/Apis/supplierApis";
import { PiTrash } from "react-icons/pi";
import { RiEdit2Fill } from "react-icons/ri";
import { PiPrinterLight } from "react-icons/pi";
import { BsInfoCircle } from "react-icons/bs";
import CalendarModal from "../../../Components/CalanderModal/CalanderModal";
import "./SalesDetails.css";

//Takunda Import Attempt for Credit Note

const SalesDetails = () => {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("id");
  const [paymentFormModal, setPaymentFormModal] = useState();
  const [editQuotationModal, setEditQuotationModal] = useState(false);

  const orderByIdApi = useOrderByIdQuery(
    {
      orderID: orderId,
      outletID: user?.outletID,
    },
    { skip: !orderId || !user?.outletID },
  );

  // Normalize new API response (GetReservations3) to existing expectations
  const orderData = orderByIdApi?.data?.data?.[0];
  const servicesList =
    orderData?.serviceTypeAndName || orderData?.services || [];

  const [orderHistoryMutation] = useCreateHistoryMutation();
  const orderHistory = useHistoryQuery(
    {
      keyId: orderId,
    },
    { skip: !orderId },
  );
  const taxPercentageApi = useTaxPercentageQuery();
  const statusApi = useStatusQuery();
  const technicianApi = useTechniciansQuery();
  const roleApi = useRolesQuery();
  const technicianRole = roleApi.data?.data?.find(
    (elem) => elem.roleName === "Technician",
  );

  // Filter dropdown items based on the current status
  const [selectedStatus, setSelectedStatus] = useState({});
  const [statusChangeConfirmationModal, setStatusChangeConfirmationModal] =
    useState(false);
  const [offDayModal, setOffDayModal] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [offDayData, setOffDayData] = useState(null);
  const [offDayProcessingComplete, setOffDayProcessingComplete] =
    useState(false);
  const [processedOffDayInfo, setProcessedOffDayInfo] = useState(null);

  // Room availability state
  const [availableRooms, setAvailableRooms] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]); // All room types (not availability)
  const [selectedRoomId, setSelectedRoomId] = useState("");
  const [roomsLoading, setRoomsLoading] = useState(false);
  const [showRoomSelection, setShowRoomSelection] = useState(false);
  const [checkingAvailability, setCheckingAvailability] = useState(false);

  // Guest-Room assignment state
  const [guestList, setGuestList] = useState([]);
  const [roomAssignments, setRoomAssignments] = useState({});
  const [assigningRooms, setAssigningRooms] = useState(false);

  const vehicleByOrderIdApi = useGetVehicleQuery(
    {
      orderId: orderId,
    },
    { skip: !orderId },
  );
  const getNoStockItems = servicesList?.filter(
    (service) => service.typeID !== 2 && service.stockQuantity < 0,
  );
  /*
   * Status ID Reference:
   *   0  = Initial
   *   1  = In Progress
   *   3  = Complete
   *   4  = Cancelled
   *   5  = Draft
   *   6  = Confirmed
   *   7  = Pending
   *   8  = Confirmed (post-Pending)
   *   9  = Check In
   *  10  = Check Out
   *  11  = Quotation
   */
  const filteredStatusArray = statusApi?.data?.data.filter((status) => {
    if (selectedStatus.id === 5) {
      // Draft → Confirmed
      return status.id === 6 && isPermissionGranted(11);
    } else if (selectedStatus.id === 1) {
      // In Progress → Ready (if stock available)
      return (
        status.id === 3 &&
        isPermissionGranted(13) &&
        getNoStockItems.length === 0
      );
    } else if (selectedStatus.id === 0) {
      // Initial → Confirmed
      return status.id === 6 && isPermissionGranted(11);
    } else if (selectedStatus.id === 6) {
      // Confirmed → In Progress or Cancelled
      return (
        (status.id === 1 &&
          isPermissionGranted(12) &&
          vehicleByOrderIdApi?.data?.data[0]?.id &&
          orderData?.adminConfirmationStatus === 1) ||
        (status.id === 4 && isPermissionGranted(4))
      );
    } else if (selectedStatus.id === 7 || selectedStatus.id === 11) {
      // Pending / Quotation → Confirmed (post-Pending) or Cancelled
      return status.id === 8 || status.id === 4;
    } else if (selectedStatus.id === 8) {
      // Confirmed (post-Pending) → Check In or Cancelled
      return status.id === 9 || (status.id === 4 && isPermissionGranted(4));
    } else if (selectedStatus.id === 9) {
      // Check In → Check Out
      return status.id === 10;
    }
    return false;
  });

  const taxPercentage = Number(taxPercentageApi?.data?.data?.masterValue) || 0; // VAT %
  // Aggregate credited amount from services (fallback 0)
  const creditedAmountTotal = (
    orderData?.services ||
    orderData?.serviceTypeAndName ||
    []
  ).reduce((sum, s) => sum + (Number(s?.creditedAmount) || 0), 0);

  const originalSubTotal = Number(orderData?.subTotal || 0);
  const adjustedSubTotalBeforeVat = Math.max(
    0,
    originalSubTotal - creditedAmountTotal,
  );
  const taxAmount = (adjustedSubTotalBeforeVat * taxPercentage) / 100;
  const adjustedSubTotal = adjustedSubTotalBeforeVat + taxAmount; // Sub Total including VAT
  const discountValue = Number(orderData?.discount || 0);
  const grossTotal = Math.max(0, adjustedSubTotal - discountValue);
  // console.log(grossTotal)

  const [updateStatusMutation, { isLoading: updateStatusLoading }] =
    useUpdateStatusMutation();

  // Off-days API hooks
  const [processOffDaysMutation, { isLoading: processOffDaysLoading }] =
    useProcessOffDaysMutation();
  const [
    updateStatusWithOffDaysMutation,
    { isLoading: updateStatusWithOffDaysLoading },
  ] = useUpdateOrderStatusWithOffDaysMutation();
  const { data: existingOffDaysData, refetch: refetchOffDays } =
    useGetOffDaysQuery(orderId, { skip: !orderId });
  const { data: offDaysHistoryData, refetch: refetchOffDaysHistory } =
    useGetOffDaysHistoryQuery(orderId, { skip: !orderId });

  console.log(
    "🚀 ~ file: SalesDetails.jsx:165 ~ SalesDetails ~ offDaysHistoryData:",
    offDaysHistoryData,
  );

  // Handle status click - check if it's a checkout status
  const handleStatusClick = (status) => {
    // Check if this is a checkout status (ID 10 - adjust as needed)
    if (status.id === 10) {
      // Show Off Day Modal first for checkout
      setPendingStatusChange(status);
      setOffDayModal(true);
    } else {
      // For non-checkout statuses, show confirmation modal directly
      setStatusChangeConfirmationModal(status);
    }
  };

  // Handle Off Day Modal confirmation - with two-step process
  const handleOffDayConfirm = async (offDayInfo) => {
    console.log("🔄 Off Day Info received:", offDayInfo);

    try {
      // Handle skip off-days scenario
      if (offDayInfo.skippedOffDays) {
        console.log(
          "⏭️ Off-days skipped, proceeding directly to checkout confirmation",
        );

        // Set the off-day info for checkout without API processing
        setOffDayData({
          offDays: offDayInfo.offDays, // Empty array for skipped
          summary: offDayInfo.summary,
          statusData: offDayInfo.statusData,
          apiResponse: null, // No API response for skipped
          pricing: offDayInfo.pricing,
          validation: offDayInfo.validation,
          skipped: true, // Flag to indicate this was skipped
        });

        // Set completion state and processed info
        setOffDayProcessingComplete(true);
        setProcessedOffDayInfo(offDayInfo);

        // Show success message for skip
        toast.success("Off-days skipped. Ready to proceed to checkout!", {
          duration: 5000,
        });

        // Don't close modal yet - show completion options
        return;
      }

      // Validate that we have off-days to process (for non-skip scenario)
      if (!offDayInfo.validation?.isValid || offDayInfo.offDays.length === 0) {
        toast.error("Please select at least one off-day before proceeding.");
        return;
      }

      // Show processing toast
      const processingToast = toast.loading("Processing off-days...");

      // Process off-days via API using the structured payload
      // ✅ Handle both single payload and multiple payloads for multi-room "ALL" scenarios
      let offDaysResult;

      if (Array.isArray(offDayInfo.apiPayload)) {
        // Multi-room "ALL" selection: Process each room individually
        console.log(
          `🏠 Processing ${offDayInfo.apiPayload.length} individual room off-days requests`,
        );
        const multiRoomResults = [];

        for (let i = 0; i < offDayInfo.apiPayload.length; i++) {
          const roomPayload = offDayInfo.apiPayload[i];
          console.log(
            `📝 Processing room ${i + 1}/${
              offDayInfo.apiPayload.length
            }: Room ID ${roomPayload.roomNo} - ${
              roomPayload.roomMetadata?.guestName
            }`,
          );

          try {
            const roomResult =
              await processOffDaysMutation(roomPayload).unwrap();
            multiRoomResults.push({
              roomId: roomPayload.roomId,
              guestName: roomPayload.roomMetadata?.guestName,
              roomNo: roomPayload.roomMetadata?.roomNo,
              result: roomResult,
              success: true,
            });
            console.log(`✅ Room ${roomPayload.roomId} processed successfully`);
          } catch (roomError) {
            console.error(
              `❌ Error processing Room ${roomPayload.roomId}:`,
              roomError,
            );
            multiRoomResults.push({
              roomId: roomPayload.roomId,
              guestName: roomPayload.roomMetadata?.guestName,
              roomNo: roomPayload.roomMetadata?.roomNo,
              error: roomError,
              success: false,
            });
          }
        }

        // Aggregate results
        const successfulRooms = multiRoomResults.filter((r) => r.success);
        const failedRooms = multiRoomResults.filter((r) => !r.success);

        console.log(
          `📊 Multi-room processing complete: ${successfulRooms.length} successful, ${failedRooms.length} failed`,
        );

        if (failedRooms.length > 0) {
          const failedRoomNames = failedRooms
            .map((r) => `${r.roomNo} (${r.guestName})`)
            .join(", ");
          throw new Error(
            `Failed to process off-days for rooms: ${failedRoomNames}`,
          );
        }

        // Create consolidated result for multi-room success
        offDaysResult = {
          status: 200,
          message: `Successfully processed off-days for ${successfulRooms.length} rooms`,
          data: {
            processedRooms: successfulRooms.length,
            totalRooms: offDayInfo.apiPayload.length,
            roomResults: multiRoomResults,
            combinedMessage: `Off-days processed for all ${
              successfulRooms.length
            } rooms: ${successfulRooms
              .map((r) => `${r.roomNo} (${r.guestName})`)
              .join(", ")}`,
          },
        };

        //add to order history
        const historyResult = await orderHistoryMutation({
          referenceId: orderId,
          actorId: user.id,
          body: offDaysResult.data.combinedMessage,
        });

        console.log("📝 Order history created:", historyResult);
      } else {
        // Single room or single payload: Use existing logic
        offDaysResult = await processOffDaysMutation(
          offDayInfo.apiPayload,
        ).unwrap();

        //add to order history
        const historyResult = await orderHistoryMutation({
          referenceId: orderId,
          actorId: user.id,
          body: offDaysResult.data.message,
        });

        console.log("📝 Order history created:", historyResult);
      }

      console.log("✅ Off-days processed successfully:", offDaysResult);

      //add to order history
      // Add to order history
      // const historyResult = await orderHistoryMutation({
      //   referenceId: orderId,
      //   actorId: user.id,
      //   body: historyMessage,
      // });

      // console.log("📝 Order history created:", historyResult);

      // Update local state with API response
      setOffDayData({
        offDays: offDayInfo.offDays,
        summary: offDayInfo.summary,
        statusData: offDayInfo.statusData,
        apiResponse: offDaysResult,
        pricing: offDayInfo.pricing,
        validation: offDayInfo.validation,
      });

      // Set completion state and processed info
      setOffDayProcessingComplete(true);
      setProcessedOffDayInfo(offDayInfo);
      refetchOffDays(); // Refresh off-days current data
      refetchOffDaysHistory(); // Refresh off-days history

      // Update processing toast
      toast.success(
        "Off-days processed successfully! Choose your next action.",
        { id: processingToast },
      );

      // Don't close modal yet - show completion options
    } catch (error) {
      console.error("❌ Error processing off-days:", error);
      toast.error(
        error?.data?.message ||
          error?.message ||
          "Failed to process off-days. Please try again.",
      );

      // Keep the modal open so user can retry or cancel
    }
  };

  // Handle proceeding to checkout after off-days processing
  const handleProceedToCheckout = async () => {
    try {
      const processingToast = toast.loading("Updating reservation status...");

      // Calculate service updates if needed (similar to existing handleStatusChange logic)
      const serviceUpdates =
        pendingStatusChange.id === 1 && servicesList?.length
          ? servicesList.map((elem) => ({
              serviceTypeId: elem.serviceID || elem.serviceTypeId,
              serviceId: elem.parentID || elem.serviceId,
              quantityReduced: elem.quantity || elem.serviceQuantity || 0,
              userId: Number(user.id),
              productServiceId: elem.productServiceID,
              stockOut: elem.quantity || elem.serviceQuantity || 0,
              stockIn: 0,
            }))
          : [];

      // Handle different scenarios based on whether off-days were skipped or processed
      let result;
      let historyMessage = `The status has been successfully updated to ${pendingStatusChange.description}.`;

      if (
        processedOffDayInfo.skipped ||
        processedOffDayInfo.offDays.length === 0
      ) {
        console.log(
          "🔄 Processing checkout without new off-days (skipped or none selected)",
        );

        // Use regular status update for skipped off-days
        const regularStatusBody = {
          orderId: Number(orderId),
          statusId: pendingStatusChange.id,
          serviceUpdates: serviceUpdates,
        };

        result = await updateStatusMutation(regularStatusBody);
        historyMessage += " Off-days selection was skipped.";
      } else {
        console.log("🔄 Processing checkout with off-days");

        // Create the enhanced order status update request with off-days
        // ✅ Handle both single and multi-room API payloads
        let statusUpdateRequest;

        if (Array.isArray(processedOffDayInfo.apiPayload)) {
          // Multi-room scenario: Use first room's data for order update, but include all room info
          const firstRoomPayload = processedOffDayInfo.apiPayload[0];
          const allRoomIds = processedOffDayInfo.apiPayload.map(
            (p) => p.roomId,
          );
          const allRoomNotes = processedOffDayInfo.apiPayload
            .map(
              (p) =>
                `Room ${p.roomMetadata?.roomNo} (${
                  p.roomMetadata?.guestName
                }): ${p.offDays.join(", ")}`,
            )
            .join("; ");

          statusUpdateRequest = {
            orderStatusUpdate: {
              orderId: firstRoomPayload.orderId,
              statusId: pendingStatusChange.id,
              serviceUpdates: serviceUpdates,
            },
            offDaysRequest: {
              orderId: firstRoomPayload.orderId,
              offDays: firstRoomPayload.offDays, // Use same off-days for all rooms
              roomId: null, // null indicates multi-room processing was already handled
              bookingStartDate: firstRoomPayload.bookingStartDate,
              bookingEndDate: firstRoomPayload.bookingEndDate,
              userId: user?.id || firstRoomPayload.userId,
              originalAmount: firstRoomPayload.originalAmount,
              notes: `Status changed to ${pendingStatusChange.description} with multi-room off-days (${processedOffDayInfo.apiPayload.length} rooms): ${allRoomNotes}`,
              multiRoomMetadata: {
                totalRooms: processedOffDayInfo.apiPayload.length,
                roomIds: allRoomIds,
                processedIndividually: true,
              },
            },
          };

          console.log(
            "🏠 Sending multi-room status+off-days update:",
            statusUpdateRequest,
          );
        } else {
          // Single room scenario: Use existing logic
          statusUpdateRequest = {
            orderStatusUpdate: {
              orderId: processedOffDayInfo.apiPayload.orderId,
              statusId: pendingStatusChange.id,
              serviceUpdates: serviceUpdates,
            },
            offDaysRequest: {
              orderId: processedOffDayInfo.apiPayload.orderId,
              offDays: processedOffDayInfo.apiPayload.offDays, // ✅ Use combined off-days (existing + new)
              roomId: processedOffDayInfo.apiPayload.roomId,
              bookingStartDate: processedOffDayInfo.apiPayload.bookingStartDate,
              bookingEndDate: processedOffDayInfo.apiPayload.bookingEndDate,
              userId: user?.id || processedOffDayInfo.apiPayload.userId,
              originalAmount: processedOffDayInfo.apiPayload.originalAmount,
              notes: `Status changed to ${
                pendingStatusChange.description
              } with all off-days: ${processedOffDayInfo.apiPayload.offDays.join(
                ", ",
              )}`,
            },
          };

          console.log(
            "🔄 Sending single room status+off-days update:",
            statusUpdateRequest,
          );
        }

        // Use the combined update endpoint
        result = await updateStatusWithOffDaysMutation(statusUpdateRequest);

        if (processedOffDayInfo && processedOffDayInfo.summary) {
          const summary = processedOffDayInfo.summary;
          historyMessage += ` Off-days processed: ${
            processedOffDayInfo.offDays.length
          } days selected (${summary.offDays} off-days, ${
            summary.usedDays
          } used days). Price reduction: R${
            processedOffDayInfo.pricing.priceReduction?.toFixed(2) || "0.00"
          }. Final amount: R${
            processedOffDayInfo.pricing.finalAmount?.toFixed(2) || "0.00"
          }.`;
        }
      }

      console.log("✅ Status updated successfully:", result);

      //   // "data": {
      //     "orderId": 154,
      //     "statusId": 10,
      //     "serviceUpdates": [],
      //     "offDays": [
      //         {
      //             "id": 25,
      //             "orderId": 154,
      //             "roomId": null,
      //             "roomName": "",
      //             "offDate": "2025-09-18T00:00:00",
      //             "priceReduction": 585.00,
      //             "createdAt": "2025-09-17T15:46:15.77",
      //             "createdBy": 8,
      //             "notes": null,
      //             "isActive": true
      //         }
      //     ],
      //     "offDaysSummary": {
      //         "id": 21,
      //         "orderId": 154,
      //         "totalOffDays": 1,
      //         "totalBookingDays": 4,
      //         "originalAmount": 2340.00,
      //         "priceReduction": 585.00,
      //         "finalAmount": 1755.00,
      //         "processedAt": "2025-09-17T15:46:15.77",
      //         "processedBy": 8,
      //         "isActive": true
      //     }
      // }

      // Dismiss loading toast
      toast.dismiss(processingToast);

      // Update selected status
      setSelectedStatus(pendingStatusChange);

      // Show success message
      const successMessage = processedOffDayInfo?.skipped
        ? `Status changed to ${pendingStatusChange.description} successfully (off-days skipped)!`
        : result?.message ||
          `Status changed to ${pendingStatusChange.description} successfully with off-days applied!`;

      toast.success(successMessage, { duration: 7000 });

      // Add to order history
      const historyResult = await orderHistoryMutation({
        referenceId: orderId,
        actorId: user.id,
        body: historyMessage,
      });

      console.log("📝 Order history created:", historyResult);

      // Refresh all data to reflect changes
      await orderByIdApi.refetch();
      await refetchOffDays(); // Refresh off-days data
      await refetchOffDaysHistory(); // Refresh off-days history
      await orderHistory.refetch(); // Refresh order history to show new activity
      // Note: Payment data shouldn't change during status/off-days update, but refresh for consistency
      await paymentByIdApi.refetch();

      // Reset all modal states
      handleOffDayCancel();
    } catch (error) {
      console.error("❌ Error updating status with off-days:", error);

      // Dismiss loading toast
      toast.dismiss();

      // Show detailed error message
      const errorMessage =
        error?.data?.message ||
        error?.message ||
        "Failed to update status with off-days. Please try again.";

      toast.error(errorMessage, { duration: 7000 });

      // Keep the modal open so user can retry or cancel
    }
  };

  // Handle closing modal without status change
  const handleOffDayCompleteClose = () => {
    // Just close the modal, off-days have been processed
    handleOffDayCancel();
    // toast.info("Off-days have been saved. You can proceed with checkout later if needed.");
  };

  // Handle Off Day Modal cancellation
  const handleOffDayCancel = () => {
    setOffDayModal(false);
    setPendingStatusChange(null);
    setOffDayData(null);
    setOffDayProcessingComplete(false);
    setProcessedOffDayInfo(null);
  };

  const handleStatusChange = async () => {
    setSelectedStatus(statusChangeConfirmationModal);

    try {
      const serviceUpdates =
        statusChangeConfirmationModal.id === 1 && servicesList?.length
          ? servicesList.map((elem) => ({
              serviceTypeId: elem.serviceID || elem.serviceTypeId,
              serviceId: elem.parentID || elem.serviceId,
              quantityReduced: elem.quantity || elem.serviceQuantity || 0,
              userId: Number(user.id),
              productServiceId: elem.productServiceID,
              stockOut: elem.quantity || elem.serviceQuantity || 0,
              stockIn: 0,
            }))
          : [
              {
                serviceTypeId: null,
                quantityReduced: null,
                userId: null,
                productServiceId: null,
                stockOut: null,
                stockIn: null,
              },
            ];

      let response;

      // Check if we have off-days data that was already processed
      if (offDayData?.apiResponse) {
        console.log(
          "🔄 Using enhanced status update with pre-processed off-days",
        );

        // Use the enhanced API that handles both off-days and status update
        const enhancedStatusBody = {
          orderId: Number(orderId),
          statusId: statusChangeConfirmationModal.id,
          serviceUpdates: serviceUpdates,
          // Off-days data is already processed, so we just include reference
          offDaysProcessed: true,
          offDaysResponse: offDayData.apiResponse,
        };

        // For now, use regular status update since off-days are already processed
        response = await updateStatusMutation(enhancedStatusBody);
      } else {
        console.log("🔄 Using standard status update (no off-days)");

        // Standard status update without off-days
        const statusBody = {
          orderId: Number(orderId),
          statusId: statusChangeConfirmationModal.id,
          serviceUpdates: serviceUpdates,
        };

        response = await updateStatusMutation(statusBody);
      }

      console.log("📊 Status update response:", response);

      if (response?.data?.status === 200) {
        setStatusChangeConfirmationModal(false);

        // Create enhanced history message
        let historyMessage = `The status has been successfully updated to ${statusChangeConfirmationModal.description}.`;

        if (offDayData?.apiResponse) {
          const { data } = offDayData.apiResponse;
          historyMessage += ` Off-days processed: ${
            data.totalOffDays
          } days with R${data.totalPriceReduction.toFixed(
            2,
          )} price reduction. Final amount: R${data.finalAmount.toFixed(2)}.`;
        }

        // Reset state
        setOffDayData(null);
        setPendingStatusChange(null);

        // Show success message
        toast.success(response?.data?.message, { duration: 7000 });

        // Add to order history
        orderHistoryMutation({
          referenceId: orderId,
          actorId: user.id,
          body: historyMessage,
        });

        // Refresh off-days data to reflect changes
        if (offDayData?.apiResponse) {
          refetchOffDays();
        }
      } else {
        toast.error(
          response?.data?.message || "Failed to update order status",
          { duration: 7000 },
        );
      }
    } catch (error) {
      console.error("❌ Error updating order status:", error);
      toast.error(
        error?.data?.message ||
          error?.message ||
          "Failed to update order status. Please try again.",
      );
    }
  };

  // UPDATE ORDER (via Reservation API)
  const [addPaymentMutation] = useAddPaymentMutation();

  const paymentByIdApi = usePaymentByIdQuery({
    orderId: orderId,
  });
  const handleAddPayment = (formData) => {
    console.log(formData);
    addPaymentMutation({
      paymentDate: new Date().toISOString(),
      customerId: orderData?.customerID || 0,
      companyID: orderData?.companyID || 0,
      customerName: orderData?.customerName,
      orderId: orderId,
      receivedAmount: formData.paidAmount,
      payAmount: formData.paidAmount,
      paymentType: formData.paymentType,
      paymentNote: formData.notes,
      utrNumber: formData.utrNumber,
    }).then((res) => {
      console.log(res);
      if (res?.data?.status === 200) {
        setPaymentFormModal(false);
        toast.success(res?.data?.message, { duration: 7000 });
        // navigate('/sales-history');
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    });
  };

  // ASSIGN TECHNICIAN
  // Find technician by id
  const [assignTechnicianMutation] = useAssignTechnicianMutation();
  const handleTechnician = (id) => {
    console.log(id);
    if (id) {
      assignTechnicianMutation({
        orderId: orderId,
        technicianId: id,
      }).then((res) => {
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message, { duration: 7000 });
        } else {
          toast.error(res?.data?.message, { duration: 7000 });
        }
      });
    } else {
      // Handle case where technician is not found
      toast.error("Technician not found", { duration: 7000 });
    }
  };

  // VEHICLE DETAILS
  const [vehicleModal, setVehicleModal] = useState();
  const [createVehicle] = useCreateVehicleMutation();
  const [updateVehicle] = useUpdateVehicleMutation();

  const handleVehicleDetailsSubmit = (formData) => {
    console.log(formData);
    if (!formData.id) {
      createVehicle(formData).then((res) => {
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message, { duration: 7000 });
          setVehicleModal(null);
        } else {
          toast.error(res?.data?.message, { duration: 7000 });
        }
      });
    } else {
      const updatePayload = {
        orderId: orderId,
        vehicleId: formData.id,
        regNumber: formData.regNumber,
        vinNumber: formData.vinNumber,
        kmRead: formData.kmRead,
        fuelRead: formData.fuelRead,
        toolsSpare: formData.toolsSpare,
        scratchesDents: formData.scratchesDents,
        imageDetails: formData.vehicleImages.map((elem, i) => ({
          imageId: elem.vehicleImageID,
          vehicleId: formData.id,
          vehicleImage: elem.vehicleImage,
        })),
      };
      console.log(updatePayload);
      updateVehicle(updatePayload).then((res) => {
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message, { duration: 7000 });
          setVehicleModal(null);
        } else {
          toast.error(res?.data?.message, { duration: 7000 });
        }
      });
    }
  };

  // REQUEST STOCKS
  const [reqStock, setReqStock] = useState({
    modal: false,
    adminId: "",
  });
  const userList = useAllExistingUsersQuery(
    {
      keynum: 1,
      outletID: user.outletID,
    },
    { skip: !reqStock.modal },
  );

  const [requestStockApi] = useRequestStockMutation();

  const requestStock = () => {
    requestStockApi({
      orderID: orderId,
      adminID: reqStock.adminId,
    }).then((res) => {
      if (res.data.status === 200) {
        navigate(`/sales-history/print-stock?id=${orderId}`);
      }
    });
  };

  // ADD REQUISITION FUNCTIONALITY
  const [reqMdl, setReqMdl] = useState();
  const [reqForm, setReqForm] = useState({
    outletName: "",
    supplierName: "",
    requisitionDate: "",
    requisitionNumber: "",
    requisitionNote: "",
    products: [],
  });
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    let newErrors = {};
    if (!reqForm.requisitionDate) {
      newErrors.requisitionDate = "Requisition date is required";
    }
    if (!reqForm.requisitionNote) {
      newErrors.requisitionNote = "Requisition note is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const [createSupplierInvoiceMutation] = useCreateSupplierInvoiceMutation();
  const handleCreateReq = () => {
    console.log(reqForm);
    if (!validateForm()) return;
    createSupplierInvoiceMutation({
      invoiceRequest: "",
      supplierID: reqForm.supplierName,
      outletID: reqForm.outletName,
      InvoiceNote: reqForm.requisitionNote,
      statusInvoice: 1,
      products: reqForm.products.map((elem) => {
        return {
          productID: elem.productId,
          quantity: elem.quantity,
          childID: elem.childId,
          serviceTypeID: elem.serviceTypeId,
        };
      }),
    }).then((res) => {
      if (res?.data?.status === 200) {
        setReqMdl(false);
        toast.success(res?.data?.message, { duration: 7000 });
      } else {
        setReqMdl(false);
        toast.error(res?.data?.message, { duration: 7000 });
      }
    });
  };

  // ADD NOTES
  const [notes, setNotes] = useState("");
  let debounceTimer;

  const submitNotes = () => {
    clearTimeout(debounceTimer); // Clear the previous timer
    debounceTimer = setTimeout(() => {
      const mapped = servicesList.map((elem) => {
        const nights = Number(elem.nights ?? elem.nightCount ?? 1) || 1;
        const rate = Number(elem.rate ?? elem.servicePrice ?? 0) || 0;
        const parentIdVal = elem.parentID || elem.parentId || 0;
        const typeIdVal =
          elem.typeID || elem.serviceTypeId || elem.serviceID || 0;
        const total = rate * nights;
        return {
          serviceID: parentIdVal,
          serviceTypeID: typeIdVal,
          typeID: typeIdVal,
          nightCount: nights,
          serviceQuantity: nights,
          defectedQuantity: 0,
          servicePrice: rate,
          detailPrice: total,
          parentID: parentIdVal,
          serviceDetailTotal: total,
          brandID: 0,
          length: 0,
          breadth: 0,
          colorCode: 0,
          orderDetailPrimaryID: elem.orderDetailPrimaryID || elem.keyID || 0,
        };
      });
      const displayedSubtotal = mapped.reduce(
        (sum, od) => sum + (Number(od.detailPrice) || 0),
        0,
      );
      const payload = {
        orderID: Number(orderId),
        phoneNumber: orderData?.customerNumber || "",
        orderDate: orderData?.orderDate || new Date().toISOString(),
        checkOutDate: orderData?.checkOutDate || undefined,
        subTotal: displayedSubtotal,
        discountType: orderData?.discountType ?? 0,
        discount: Number(orderData?.discount ?? 0),
        total: displayedSubtotal,
        note: notes || orderData?.notes || "",
        instruction: orderData?.instruction || "",
        status: orderData?.statusID ?? 0,
        paymentDate: new Date().toISOString(),
        receivedAmount: Number(orderData?.amountPaid ?? 0),
        payAmount: Number(orderData?.payAmount ?? 0),
        paymentType: orderData?.paymentType ?? 0,
        paymentNote: orderData?.paymentNote || "",
        // Only send new details (no existing key/orderDetail ids)
        orderDetails: (orderData?.serviceDetails || [])
          .filter(
            (elem) =>
              !(elem?.orderDetailPrimaryID || elem?.keyID || elem?.keyId),
          )
          .map((elem) => {
            const nights = Number(elem?.nights ?? elem?.nightCount ?? 1) || 1;
            const rate = Number(elem?.serviceRate ?? elem?.rate ?? 0) || 0;
            const parentIdVal =
              elem?.parentID ?? elem?.parentId ?? elem?.serviceId ?? 0;
            const typeIdVal =
              elem?.typeID ?? elem?.typeId ?? elem?.serviceTypeID ?? 0;
            const total = Number(elem?.detailPrice ?? rate * nights);
            return {
              serviceID: parentIdVal,
              serviceTypeID: typeIdVal,
              typeID: typeIdVal,
              nightCount: nights,
              serviceQuantity: nights,
              defectedQuantity: 0,
              servicePrice: rate,
              detailPrice: total,
              parentID: parentIdVal,
              serviceDetailTotal: total,
              brandID: 0,
              length: 0,
              breadth: 0,
              colorCode: 0,
              orderDetailPrimaryID: 0,
            };
          }),
        subCustomers: orderData?.subCustomers || [],
      };
      updateReservation(payload).then((res) => {
        // no toast spam; silent save
        console.debug("Notes autosave updateReservation status:", res?.status);
      });
    }, 2000);
  };

  // EDIT QUOTATION
  const handleEditQuotation = (formData) => {
    // Form now handles update via updateReservation; just refresh
    orderByIdApi.refetch();
    setEditQuotationModal(false);
  };

  useEffect(() => {
    const fallbackDescription = () => {
      if (!orderData) return "";
      if (orderData.statusDescription) return orderData.statusDescription;
      const match = statusApi?.data?.data?.find(
        (s) => s.id === orderData.statusID,
      );
      if (match?.description) return match.description;
      switch (orderData.statusID) {
        case 11:
          return "Quotation";
        case 5:
          return "Draft";
        case 6:
          return "Confirmed";
        case 1:
          return "In Progress";
        case 3:
          return "Completed";
        case 4:
          return "Cancelled";
        default:
          return `Status ${orderData.statusID}`;
      }
    };
    setSelectedStatus({
      id: orderData?.statusID,
      description: fallbackDescription(),
    });
    setNotes(orderData?.notes);

    setReqForm({
      ...reqForm,
      outletName: user.outletID,
      supplierName: orderData?.supplierID,
      requisitionNumber: orderData?.invoiceNumber,
      requisitionNote: orderData?.invoiceNote,
      products: servicesList
        ?.filter(
          (product) => product.typeID === 1 || product.serviceTypeId === 1,
        )
        .map((product) => ({
          productId: product.parentID || product.parentId,
          childId: product.childID || product.serviceId,
          productName: product.serviceName || product.productServiceName,
          quantity:
            Number(product.quantity || product.serviceQuantity || 0) +
            Math.abs(Number(product.backOrderQuantity || 0)),
          serviceTypeId: product.serviceID || product.serviceTypeId,
        })),
      requisitionDate: orderData?.orderDate
        ? orderData.orderDate.split("T")[0]
        : "",
    });
  }, [orderByIdApi.isSuccess, statusApi.isSuccess]);

  // Check if booking has accommodation/bed and fetch room availability
  useEffect(() => {
    const checkAndFetchRooms = async () => {
      if (!orderData || !servicesList?.length) return;

      console.log("🏠 Checking services for accommodation/bed:", servicesList);

      // Check if any service contains "accommodation", "accomodation" (typo), or "bed"
      const hasAccommodation = servicesList.some((service) => {
        const serviceName = (
          service.serviceName ||
          service.productServiceName ||
          ""
        ).toLowerCase();
        console.log("🔍 Checking service name:", serviceName);
        return (
          serviceName.includes("accommodation") ||
          serviceName.includes("accomdation") || // Handle typo
          serviceName.includes("accomodation") || // Handle typo
          serviceName.includes("bed")
        );
      });

      console.log("🏠 Has accommodation/bed:", hasAccommodation);
      console.log("📊 OrderData:", orderData);
      console.log("📅 OrderData dates:", {
        orderDate: orderData?.orderDate,
        checkOutDate: orderData?.checkOutDate,
        hasOrderDate: !!orderData?.orderDate,
        hasCheckOutDate: !!orderData?.checkOutDate,
      });

      if (hasAccommodation && orderData?.orderDate && orderData?.checkOutDate) {
        console.log("✅ Showing room selection");
        setShowRoomSelection(true);
        setRoomsLoading(true);

        try {
          // Format dates for API
          const startDate = orderData.orderDate.split("T")[0];
          const endDate = orderData.checkOutDate.split("T")[0];
          const outletId = orderData.outletID || user.outletID;

          console.log("📞 Calling checkRoomAvailability with:", {
            startDate,
            endDate,
            outletId,
          });

          const roomData = await checkRoomAvailability(
            startDate,
            endDate,
            outletId,
          );
          console.log("🏠 Room data received:", roomData);

          // Handle the API response structure - it's an array with rooms inside the first object
          if (
            roomData &&
            Array.isArray(roomData) &&
            roomData.length > 0 &&
            roomData[0].rooms &&
            Array.isArray(roomData[0].rooms)
          ) {
            const roomsData = roomData[0];
            console.log("🏠 All rooms from API:", roomsData.rooms);
            console.log(
              "🏠 Available rooms count from API:",
              roomsData.availableRoomsCount,
            );

            // Show ALL rooms (not just available ones) so user can pick any room
            setRoomTypes(roomsData.rooms);

            // Separate available and booked rooms for display
            const availableRoomList = roomsData.rooms.filter(
              (room) => !room.isBooked,
            );
            const bookedRoomList = roomsData.rooms.filter(
              (room) => room.isBooked,
            );

            console.log("✅ Available rooms:", availableRoomList);
            console.log("❌ Booked rooms:", bookedRoomList);
            console.log("📊 Total rooms:", roomsData.rooms.length);

            setAvailableRooms(availableRoomList);
          } else {
            console.log("❌ Invalid API response structure:", roomData);
            setRoomTypes([]);
            setAvailableRooms([]);
          }
        } catch (error) {
          console.error("❌ Error fetching rooms:", error);
          toast.error("Failed to load rooms");
        } finally {
          setRoomsLoading(false);
        }
      } else {
        console.log("❌ Not showing room selection");
        console.log("❌ Reasons:", {
          hasAccommodation,
          hasOrderDate: !!orderData?.orderDate,
          hasCheckOutDate: !!orderData?.checkOutDate,
          orderData: orderData,
        });
        setShowRoomSelection(false);
        setRoomTypes([]);
        setAvailableRooms([]);
      }
    };

    checkAndFetchRooms();
  }, [orderData, servicesList, user.outletID]);

  // Create guest list based on accommodation services
  useEffect(() => {
    if (!servicesList?.length || !showRoomSelection) return;

    // Find accommodation services
    const accommodationServices = servicesList.filter((service) => {
      const serviceName = (
        service.serviceName ||
        service.productServiceName ||
        ""
      ).toLowerCase();
      return (
        serviceName.includes("accommodation") ||
        serviceName.includes("accomdation") ||
        serviceName.includes("accomodation") ||
        serviceName.includes("bed")
      );
    });

    console.log("🏠 Accommodation services found:", accommodationServices);

    const guests = [];
    accommodationServices.forEach((service, serviceIndex) => {
      // Check if there are sub-customers for this service
      if (service.subCustomerName && service.subCustomerName.trim()) {
        guests.push({
          id: `sub-${service.subCustomerId || serviceIndex}`,
          name: service.subCustomerName,
          email: service.subCustomerEmail || "",
          serviceId: service.serviceId,
          isSubCustomer: true,
          checkIn: service.subCustomerCheckIn,
          checkOut: service.subCustomerCheckOut,
        });
      } else {
        // For services without sub-customers, create guest entries based on quantity
        const quantity = service.serviceQuantity || 1;
        for (let i = 0; i < quantity; i++) {
          guests.push({
            id: `main-${serviceIndex}-${i}`,
            name:
              i === 0
                ? `${orderData?.customerName || "Main Guest"}`
                : `${orderData?.customerName || "Guest"} - Room ${i + 1}`,
            email: i === 0 ? orderData?.emails || "" : "",
            serviceId: service.serviceId,
            isSubCustomer: false,
            serviceIndex: serviceIndex,
            roomIndex: i,
          });
        }
      }
    });

    console.log("👥 Guest list created:", guests);
    setGuestList(guests);

    // Initialize room assignments
    const initialAssignments = {};
    guests.forEach((guest) => {
      initialAssignments[guest.id] = "";
    });
    setRoomAssignments(initialAssignments);
  }, [servicesList, showRoomSelection, orderData]);

  // Check if rooms are already assigned
  const hasAssignedRooms = useMemo(() => {
    if (!orderData?.services) return false;

    const accommodationServices = orderData.services.filter((service) =>
      service.productServiceName?.toLowerCase().includes("accom"),
    );

    return accommodationServices.some(
      (service) => service.roomNo && service.roomNo.trim() !== "",
    );
  }, [orderData]);

  // Function to handle room assignment
  const handleAssignRooms = async () => {
    console.log("🚀 handleAssignRooms called");

    const assignedRooms = Object.entries(roomAssignments).filter(
      ([guestId, roomValue]) => roomValue,
    );

    console.log("📋 Room assignments:", roomAssignments);
    console.log("📋 Filtered assigned rooms:", assignedRooms);

    if (assignedRooms.length === 0) {
      console.log("❌ No rooms assigned");
      toast.error("Please assign at least one room before proceeding.");
      return;
    }

    console.log("✅ Starting room assignment process");
    setAssigningRooms(true);

    try {
      const assignments = [];

      for (const [guestId, roomValue] of assignedRooms) {
        // Parse the room value (format: "index-roomTypeName")
        const [roomIndex, roomTypeName] = roomValue.split("-");
        const selectedRoom = roomTypes[parseInt(roomIndex)];

        if (selectedRoom) {
          // Find the guest details
          const guest = guestList.find((g) => g.id === guestId);

          // For company bookings, find the specific service for this guest
          // Match by subCustomerId or subCustomerName
          let guestRoomId = selectedRoom.serviceId; // Default fallback

          if (orderData?.services) {
            const guestService = orderData.services.find((service) => {
              // Try to match by subCustomerId first (most reliable)
              if (guest?.subCustomerId && service.subCustomerId) {
                return service.subCustomerId === guest.subCustomerId;
              }
              // Fallback: match by name if no subCustomerId
              if (guest?.name && service.subCustomerName) {
                return service.subCustomerName.trim() === guest.name.trim();
              }
              return false;
            });

            if (guestService) {
              guestRoomId = guestService.roomId;
              console.log(
                `🔍 Found specific roomId ${guestRoomId} for guest ${guest?.name}`,
              );
            } else {
              // For individual bookings, try to find the accommodation service
              const accommodationService = orderData.services.find((service) =>
                service.productServiceName?.toLowerCase().includes("accom"),
              );

              if (accommodationService && accommodationService.roomId) {
                guestRoomId = accommodationService.roomId;
                console.log(
                  `🔍 Using accommodation service roomId ${guestRoomId} for individual booking guest ${guest?.name}`,
                );
              } else {
                console.log(
                  `⚠️ No specific service found for guest ${guest?.name}, using selected room serviceId ${selectedRoom.serviceId}`,
                );
              }
            }
          }

          // Debug: Log the selected room structure
          console.log("🔍 Selected room from availability:", selectedRoom);
          console.log("🔍 Final roomId for guest:", guestRoomId);

          assignments.push({
            guestId,
            guestName: guest?.name,
            roomId: guestRoomId, // Use the guest-specific roomId
            roomTypeName: selectedRoom.serviceTypeName,
            orderId: orderData?.orderId,
          });
        }
      }

      console.log("🎯 Room assignments to process:", assignments);

      // Prepare assignments array for API (remove extra fields)
      const apiAssignments = assignments.map((assignment) => ({
        roomId: assignment.roomId,
        roomTypeName: assignment.roomTypeName,
        orderId: assignment.orderId,
      }));

      console.log("📞 Sending assignments to API:", apiAssignments);
      console.log("📞 About to call assignRoomType function...");

      // Send all assignments in a single API call
      const result = await assignRoomType(apiAssignments);

      console.log("📞 API call completed, result:", result);

      if (result === null) {
        console.log("❌ API returned null, stopping here");
        // API function already showed error toast, just return
        return;
      }

      console.log("✅ API call successful, navigating...");

      // Refresh the order data to get updated room assignments
      orderByIdApi.refetch();

      // Navigate back to sales history after successful assignment
      setTimeout(() => {
        navigate("/sales-history");
      }, 1500); // Small delay to show the success message
    } catch (error) {
      console.error("❌ Error assigning rooms:", error);
      // Don't show error toast here since API function already handles it
      // toast.error("Failed to assign rooms. Please try again.");
    } finally {
      console.log("🔄 Setting assigningRooms to false");
      setAssigningRooms(false);
    }
  };

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-2">
        <div className="col">
          <h5 className="fw-500 text-white">
            Order Details {orderData && `- ${orderData.orderNumber}`}
          </h5>
        </div>
      </div>
      {orderByIdApi.isError && (
        <div className="card">
          <div className="card-body">
            <Error />
          </div>
        </div>
      )}
      {orderByIdApi.isLoading && (
        <div className="card">
          <div className="card-body">
            <Loader height="500px" />
          </div>
        </div>
      )}
      {orderByIdApi.isSuccess && (
        <>
          <div className="row">
            <div className="col-md-9" id="invoiceToPrint">
              <div className="card mb-4">
                <div className="card-header p-4">
                  <div className="row">
                    <div className="col-lg-8 col-md-7">
                      <h5 className="text-uppercase fw-600 mb-1">
                        {orderData?.outletName}
                      </h5>
                      <p className="text-sm mb-0">{orderData?.outletPhone}</p>
                      <p className="text-sm mb-0">{orderData?.outletAddress}</p>
                    </div>
                    <div className="col-lg-4 col-md-5">
                      <h6 className="fw-bold">
                        <span>Order ID -</span>
                        <span className="ms-2">{orderData?.orderNumber}</span>
                      </h6>
                      {/* <p className="text-sm mb-1">
                        <span>Check In Date:</span>
                        <span className="fw-600 ms-2">
                          {orderData?.orderDate
                            ? formatDate(orderData.orderDate)
                            : "-"}
                        </span>
                      </p>
                      <p className="text-sm mb-1">
                        <span>Check Out Date:</span>
                        <span className="fw-600 ms-2">
                          {orderData?.checkOutDate
                            ? formatDate(orderData.checkOutDate)
                            : "-"}
                        </span>
                      </p> */}
                      <div className="d-flex align-items-center">
                        <div className="me-3">
                          <span className="text-sm fw-600">
                            Reservation Status
                          </span>
                        </div>

                        {isPermissionGranted(3) ? (
                          selectedStatus.id === 5 ? (
                            // IF DRAFT
                            <Dropdown align="end">
                              <Dropdown.Toggle
                                className={`badge mb-0 statusDropdown`}
                                disabled={
                                  filteredStatusArray?.length === 0 ||
                                  updateStatusLoading ||
                                  processOffDaysLoading ||
                                  updateStatusWithOffDaysLoading
                                }
                              >
                                {updateStatusLoading ||
                                processOffDaysLoading ||
                                updateStatusWithOffDaysLoading ? (
                                  <>
                                    <div
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    Processing...
                                  </>
                                ) : (
                                  <>{selectedStatus.description} &nbsp;</>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {filteredStatusArray?.map((status) => (
                                  <Dropdown.Item
                                    key={status.id}
                                    className={
                                      status?.description ===
                                        selectedStatus.description &&
                                      `badge-primary`
                                    }
                                    onClick={() => handleStatusClick(status)}
                                  >
                                    <span className="text-capitalize">
                                      {status.description}
                                    </span>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : selectedStatus.id === 3 ? (
                            // IF COMPLETED
                            <span className={`badge mb-0 bg-success`}>
                              {selectedStatus.description} &nbsp;
                            </span>
                          ) : selectedStatus.id === 4 ? (
                            // IF CANCELLED
                            <span className={`badge mb-0 bg-danger`}>
                              {selectedStatus.description} &nbsp;
                            </span>
                          ) : selectedStatus.id === 7 ||
                            selectedStatus.id === 11 ? (
                            // IF NEW STATUS or 11
                            <Dropdown align="end">
                              <Dropdown.Toggle
                                className={`badge mb-0 statusDropdown`}
                                disabled={
                                  filteredStatusArray?.length === 0 ||
                                  updateStatusLoading ||
                                  processOffDaysLoading ||
                                  updateStatusWithOffDaysLoading
                                }
                              >
                                {updateStatusLoading ||
                                processOffDaysLoading ||
                                updateStatusWithOffDaysLoading ? (
                                  <>
                                    <div
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    Processing...
                                  </>
                                ) : (
                                  <>{selectedStatus.description} &nbsp;</>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {filteredStatusArray?.map((status) => (
                                  <Dropdown.Item
                                    key={status.id}
                                    className={
                                      status?.description ===
                                        selectedStatus.description &&
                                      `badge-primary`
                                    }
                                    onClick={() => handleStatusClick(status)}
                                  >
                                    <span className="text-capitalize">
                                      {status.description}
                                    </span>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : (
                            // ELSE CASE
                            <Dropdown align="end">
                              <Dropdown.Toggle
                                className={`badge mb-0 statusDropdown`}
                                disabled={
                                  filteredStatusArray?.length === 0 ||
                                  updateStatusLoading ||
                                  processOffDaysLoading ||
                                  updateStatusWithOffDaysLoading
                                }
                              >
                                {updateStatusLoading ||
                                processOffDaysLoading ||
                                updateStatusWithOffDaysLoading ? (
                                  <>
                                    <div
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    >
                                      <span className="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                    Processing...
                                  </>
                                ) : (
                                  <>{selectedStatus.description} &nbsp;</>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {filteredStatusArray?.map((status) => (
                                  <Dropdown.Item
                                    key={status.id}
                                    className={
                                      status?.description ===
                                        selectedStatus.description &&
                                      `badge-primary`
                                    }
                                    onClick={() => handleStatusClick(status)}
                                  >
                                    <span className="text-capitalize">
                                      {status.description}
                                    </span>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          )
                        ) : (
                          <span className="badge badge-primary mb-0">
                            {selectedStatus.description}
                          </span>
                        )}
                      </div>
                      {selectedStatus.id === 1 &&
                        getNoStockItems.length > 0 && (
                          <div className="text-xs text-danger mt-2">
                            {`Status change not allowed due to out-of-stock ${
                              getNoStockItems.length > 1 ? "items" : "item"
                            }.`}
                          </div>
                        )}
                      {selectedStatus.id === 6 &&
                        technicianRole?.roleID === user.role_Id &&
                        vehicleByOrderIdApi?.data?.data.length < 1 && (
                          <div className="text-xs text-danger mt-2">
                            {`You can change the status to In Progress after adding vehicle details.`}
                          </div>
                        )}

                      {selectedStatus.id === 6 &&
                        orderData?.adminConfirmationStatus === 0 && (
                          <div className="text-xs text-danger mt-2">
                            {`You can change the status to In Progress after admin confirm stock requisition.`}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  {/* ROOM SELECTION NOTIFICATION - Only for accommodation bookings */}
                  {showRoomSelection &&
                    (selectedStatus.id === 7 || selectedStatus.id === 11) && (
                      <div
                        className="mb-3 p-2"
                        style={{
                          backgroundColor: "#fff3cd",
                          border: "1px solid #ffeaa7",
                          borderRadius: "6px",
                          borderLeft: "3px solid #f39c12",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <i
                            className="fas fa-bed me-2"
                            style={{ color: "#f39c12", fontSize: "1em" }}
                          ></i>
                          <span
                            style={{ color: "#856404", fontSize: "0.85em" }}
                          >
                            <strong>Room Assignment Required:</strong> If you
                            confirm this booking, please scroll down and select
                            the room(s) for the guest(s).
                          </span>
                        </div>
                      </div>
                    )}

                  {/* Show confirmation message when status is confirmed */}
                  {showRoomSelection && selectedStatus.id === 8 && (
                    <div
                      className="mb-3 p-2"
                      style={{
                        backgroundColor: "#d1ecf1",
                        border: "1px solid #bee5eb",
                        borderRadius: "6px",
                        borderLeft: "3px solid #17a2b8",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <i
                          className="fas fa-check-circle me-2"
                          style={{ color: "#17a2b8", fontSize: "1em" }}
                        ></i>
                        <span style={{ color: "#0c5460", fontSize: "0.85em" }}>
                          <strong>Booking Confirmed!</strong> Please scroll down
                          and assign room(s) to your guest(s).
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="table-responsive">
                    <table className="table align-items-center mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-3">
                            #
                          </th>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-0">
                            Product/Service Name
                          </th>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-0">
                            ROOM NR
                          </th>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-0">
                            Rate
                          </th>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-2 text-center">
                            cHECK IN DATE
                          </th>
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-3 text-center">
                            cHECK OUT DATE
                          </th>
                          {/* <th className="text-uppercase text-secondary text-xs opacity-7 px-3 text-center">
                            Booking QTY
                          </th> */}
                          <th className="text-uppercase text-secondary text-xs opacity-7 px-0">
                            Total
                          </th>
                          <th className="text-uppercase text-danger text-xs opacity-7 px-0">
                            Credited Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {servicesList?.map((service, index) => (
                          <tr
                            key={
                              service.serviceID || service.serviceId || index
                            }
                          >
                            <td>
                              <p className="text-sm mb-0 px-3">{index + 1}</p>
                            </td>
                            <td className="px-0">
                              <div className="d-flex flex-column">
                                <h6 className="mb-0 text-sm">
                                  {service.serviceName ||
                                    service.productServiceName}
                                </h6>
                                <p className="mb-0 text-xs">
                                  {service.service_type_name}
                                </p>
                                {service.serviceCode && (
                                  <p className="mb-0 text-xs">
                                    {service.serviceCode}
                                  </p>
                                )}
                              </div>
                            </td>
                            <td className="px-0">
                              <p className="text-sm mb-0">
                                {service.roomNumber || service.roomNo || "-"}
                              </p>
                            </td>
                            <td className="px-0">
                              <p className="text-sm mb-0">
                                R{" "}
                                {(service.rate ?? service.servicePrice)?.toFixed
                                  ? (
                                      service.rate ?? service.servicePrice
                                    ).toFixed(2)
                                  : (service.rate ?? service.servicePrice)}
                              </p>
                            </td>
                            <td className="px-2 text-center">
                              <p className="text-sm mb-0">
                                {service?.subCustomerCheckIn
                                  ? formatDate(service.subCustomerCheckIn)
                                  : orderData?.orderDate
                                    ? formatDate(orderData.orderDate)
                                    : "-"}
                              </p>
                            </td>
                            <td className="px-0">
                              <p className="text-sm mb-0 text-center">
                                {service?.subCustomerCheckOut
                                  ? formatDate(service.subCustomerCheckOut)
                                  : orderData?.checkOutDate
                                    ? formatDate(orderData.checkOutDate)
                                    : "-"}
                              </p>
                            </td>
                            <td className="px-0">
                              <p className="text-sm mb-0">
                                {(() => {
                                  const rate =
                                    (service.rate ?? service.servicePrice) || 0;
                                  const qty =
                                    (service.quantity ??
                                      service.serviceQuantity ??
                                      1) ||
                                    1;
                                  const total =
                                    service.service_detail_total ?? rate * qty;
                                  return `R ${
                                    total.toFixed ? total.toFixed(2) : total
                                  }`;
                                })()}
                              </p>
                            </td>
                            <td className="px-2">
                              <p className="text-sm mb-0 text-danger fw-500">
                                {`- R${(
                                  Number(service.creditedAmount) || 0
                                ).toFixed(2)}`}
                              </p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-footer px-4">
                  <div className="row">
                    <div className="col-md-8 mb-3">
                      <h6 className="mb-2 fw-500">Invoice To:</h6>
                      <h6 className="mb-1 fw-500 text-sm">
                        {orderData?.customerName}
                      </h6>
                      <p className="text-sm mb-0">
                        {orderData?.customerNumber}
                      </p>
                      <p className="text-sm mb-3">{orderData?.email}</p>
                      <p className="text-sm mb-0">GST No: {orderData?.gstNo}</p>
                    </div>
                    <div className="col-md-4 mb-3">
                      <h6 className="fw-500 mb-2">Payment Details:</h6>
                      <div className="row mb-2 align-items-center">
                        <div className="col text-sm">Original Sub Total:</div>
                        <div className="col-auto text-sm fw-500">
                          R {originalSubTotal.toFixed(2)}
                        </div>
                      </div>
                      <div className="row mb-2 align-items-center">
                        <div className="col text-sm">Credited Amount:</div>
                        <div className="col-auto text-sm text-danger fw-500">
                          - R {creditedAmountTotal.toFixed(2)}
                        </div>
                      </div>
                      <hr className="my-2" />
                      <div className="row align-items-center">
                        <div className="col text-sm fw-600">Gross Total:</div>
                        <div className="col-auto text-sm text-dark fw-600">
                          R{" "}
                          {Math.max(
                            0,
                            originalSubTotal - creditedAmountTotal,
                          ).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="bg-secondary" />

                  {/* OFF-DAYS HISTORICAL SUMMARY */}
                  {offDaysHistoryData?.data?.length > 0 && (
                    <>
                      <h6 className="mb-3 text-sm fw-500 d-flex align-items-center">
                        <i
                          className="fas fa-calendar-times me-2"
                          style={{ color: "#b99028" }}
                        ></i>
                        Off-Days Processing History
                        <span className="badge bg-info ms-2">
                          {offDaysHistoryData.data.length}
                        </span>
                      </h6>
                      <div className="row g-3 mb-4">
                        {offDaysHistoryData.data.map((historyRecord, index) => {
                          // Parse off-days JSON if it's a string
                          let offDaysList = [];
                          try {
                            console.log(
                              "Processing historyRecord:",
                              historyRecord,
                            );
                            console.log("Raw offDays:", historyRecord.offDays);
                            if (
                              typeof historyRecord.offDays === "string" &&
                              historyRecord.offDays.trim() !== ""
                            ) {
                              // Handle escaped JSON string
                              let cleanJson = historyRecord.offDays.replace(
                                /\\\"/g,
                                '"',
                              );
                              console.log("Cleaned JSON:", cleanJson);
                              offDaysList = JSON.parse(cleanJson);
                              console.log("Parsed offDaysList:", offDaysList);
                            } else if (Array.isArray(historyRecord.offDays)) {
                              offDaysList = historyRecord.offDays;
                              console.log("Array offDaysList:", offDaysList);
                            }
                          } catch (e) {
                            console.error(
                              "JSON parsing error:",
                              e,
                              "for value:",
                              historyRecord.offDays,
                            );
                            offDaysList = [];
                          }

                          // Helper function to find subcustomer name by room ID
                          const getSubCustomerByRoom = (roomId) => {
                            if (!roomId) return null;

                            // Find subcustomer by matching room ID in services array
                            const service = orderData?.services?.find(
                              (service) =>
                                service.roomId === roomId ||
                                service.roomNo === `Room ${roomId}` ||
                                service.roomNumber === roomId,
                            );

                            // Also check in serviceTypeAndName if services doesn't exist
                            const serviceFromTypeAndName =
                              orderData?.serviceTypeAndName?.find(
                                (service) =>
                                  service.roomId === roomId ||
                                  service.roomNo === `Room ${roomId}` ||
                                  service.roomNumber === roomId,
                              );

                            return service || serviceFromTypeAndName;
                          };

                          const serviceWithSubCustomer = getSubCustomerByRoom(
                            historyRecord.roomId,
                          );
                          console.log(
                            "Matched serviceWithSubCustomer:",
                            serviceWithSubCustomer,
                          );
                          const displayName =
                            serviceWithSubCustomer?.subCustomerName;
                          const roomDisplay =
                            serviceWithSubCustomer?.roomNo &&
                            serviceWithSubCustomer.roomNo.trim() !== ""
                              ? `Room ${serviceWithSubCustomer.roomNo}`
                              : "All Rooms";

                          return (
                            <div
                              key={historyRecord.id || index}
                              className="col-md-6"
                            >
                              <div
                                className="card border-0"
                                style={{
                                  background:
                                    "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                }}
                              >
                                <div className="card-body p-3">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="me-2"
                                        style={{
                                          width: "8px",
                                          height: "8px",
                                          background: historyRecord.isActive
                                            ? "#28a745"
                                            : "#dc3545",
                                          borderRadius: "50%",
                                        }}
                                      ></div>
                                      <div>
                                        <h6 className="mb-0 text-dark fw-bold">
                                          {displayName || roomDisplay}
                                        </h6>
                                        {displayName && (
                                          <small className="text-muted">
                                            {roomDisplay}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                    <span className="badge bg-primary">
                                      {offDaysList.length} day
                                      {offDaysList.length !== 1 ? "s" : ""}
                                    </span>
                                  </div>

                                  <div className="row text-center g-0 mb-2">
                                    {/* <div className="col-3">
                                      <div style={{color:"#28a745"}} className="h6 mb-1">
                                        {historyRecord.usedDays || 0}
                                      </div>
                                      <small className="text-muted">Used</small>
                                    </div> */}
                                    <div className="col-3">
                                      <div
                                        style={{ color: "#6c757d" }}
                                        className="h6 mb-1"
                                      >
                                        {historyRecord.totalBookingDays || 0}
                                      </div>
                                      <small className="text-muted">
                                        Total
                                      </small>
                                    </div>
                                    <div className="col-3">
                                      <div
                                        style={{ color: "#dc3545" }}
                                        className="h6 mb-1"
                                      >
                                        {offDaysList.length}
                                      </div>
                                      <small className="text-muted">
                                        Used Off Days
                                      </small>
                                    </div>
                                    <div className="col-3">
                                      <div
                                        style={{ color: "#b99028" }}
                                        className="h6 mb-1"
                                      >
                                        R{" "}
                                        {(
                                          historyRecord.priceReduction || 0
                                        ).toFixed(2)}
                                      </div>
                                      <small className="text-muted">
                                        Refund
                                      </small>
                                    </div>
                                  </div>

                                  {offDaysList.length > 0 && (
                                    <div className="mt-2">
                                      <small className="text-muted">
                                        <strong>Dates:</strong>{" "}
                                        {offDaysList
                                          .map((item) => item.date || item)
                                          .join(", ")}
                                      </small>
                                    </div>
                                  )}

                                  {/* <div className="row mt-2">
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <strong>Original:</strong> R {(historyRecord.originalAmount || 0).toFixed(2)}
                                      </small>
                                    </div>
                                    <div className="col-6">
                                      <small className="text-muted">
                                        <strong>Final:</strong> R {(historyRecord.finalAmount || 0).toFixed(2)}
                                      </small>
                                    </div>
                                  </div> */}

                                  <div className="mt-2 pt-2 border-top">
                                    <small className="text-muted">
                                      <i className="fas fa-clock me-1"></i>
                                      {new Date(
                                        historyRecord.processedAt,
                                      ).toLocaleString()}
                                      {!historyRecord.isActive && (
                                        <span className="badge bg-secondary ms-2">
                                          Inactive
                                        </span>
                                      )}
                                    </small>
                                  </div>

                                  {/* {historyRecord.notes && (
                                    <div className="mt-2">
                                      <small className="text-muted font-italic">
                                        "{historyRecord.notes}"
                                      </small>
                                    </div>
                                  )} */}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <hr className="bg-secondary" />
                    </>
                  )}

                  {/* ROOM SELECTION */}
                  {showRoomSelection && (
                    <>
                      <h6 className="mb-3 text-sm fw-500 d-flex align-items-center">
                        <i
                          className="fas fa-bed me-2"
                          style={{ color: "#28a745" }}
                        ></i>
                        Room Selection
                      </h6>

                      {roomsLoading ? (
                        <div className="text-center py-3">
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          Loading rooms...
                        </div>
                      ) : roomTypes.length > 0 && guestList.length > 0 ? (
                        hasAssignedRooms ? (
                          // Show already assigned rooms
                          <div>
                            <div className="alert alert-success">
                              <i className="fas fa-check-circle me-2"></i>
                              <strong>Rooms Already Assigned</strong>
                              <p className="mb-0 mt-2">
                                The following rooms have been assigned for this
                                accommodation booking:
                              </p>
                            </div>

                            {orderData.services
                              .filter(
                                (service) =>
                                  service.productServiceName
                                    ?.toLowerCase()
                                    .includes("accom") &&
                                  service.roomNo &&
                                  service.roomNo.trim() !== "",
                              )
                              .map((service, index) => (
                                <div
                                  key={index}
                                  className="card mb-2 border-success"
                                >
                                  <div className="card-body p-3">
                                    <div className="row align-items-center">
                                      <div className="col-md-6">
                                        <div>
                                          <strong className="text-success">
                                            <i className="fas fa-bed me-2"></i>
                                            {service.roomNo}
                                          </strong>
                                          <div
                                            className="text-muted"
                                            style={{ fontSize: "0.85em" }}
                                          >
                                            {service.service_type_name}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="text-end">
                                          <span className="badge bg-success">
                                            <i className="fas fa-check me-1"></i>
                                            Assigned
                                          </span>
                                          {service.subCustomerName && (
                                            <div
                                              className="text-muted mt-1"
                                              style={{ fontSize: "0.8em" }}
                                            >
                                              Guest: {service.subCustomerName}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        ) : (
                          // Show room assignment interface (existing code)
                          <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h6 className="mb-0">Assign Rooms to Guests:</h6>
                              <small className="text-muted">
                                {guestList.length} guest(s) •{" "}
                                {
                                  roomTypes.filter((room) => !room.isBooked)
                                    .length
                                }{" "}
                                available room(s)
                              </small>
                            </div>

                            {/* Room Assignment List */}
                            {guestList.map((guest, index) => (
                              <div key={guest.id} className="card mb-3">
                                <div className="card-body p-3">
                                  <div className="row align-items-center">
                                    <div className="col-md-4">
                                      <div>
                                        <strong className="text-sm">
                                          {guest.name}
                                        </strong>
                                        {guest.email && (
                                          <div
                                            className="text-muted"
                                            style={{ fontSize: "0.8em" }}
                                          >
                                            {guest.email}
                                          </div>
                                        )}
                                        {guest.isSubCustomer && (
                                          <span
                                            className="badge bg-info text-white me-1"
                                            style={{ fontSize: "0.7em" }}
                                          >
                                            Sub-Customer
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-8">
                                      <label className="form-label text-sm mb-1">
                                        Select Room:
                                      </label>
                                      <select
                                        className="form-select form-select-sm"
                                        value={roomAssignments[guest.id] || ""}
                                        onChange={(e) => {
                                          setRoomAssignments((prev) => ({
                                            ...prev,
                                            [guest.id]: e.target.value,
                                          }));
                                        }}
                                      >
                                        <option value="">
                                          Choose a room for{" "}
                                          {guest.name.split(" - ")[0]}...
                                        </option>
                                        {roomTypes.map((room, roomIndex) => (
                                          <option
                                            key={`${guest.id}-room-${roomIndex}-${room.serviceTypeName}`}
                                            value={`${roomIndex}-${room.serviceTypeName}`}
                                            style={{
                                              color: room.isBooked
                                                ? "#dc3545"
                                                : "#28a745",
                                            }}
                                          >
                                            {room.serviceTypeName}
                                            {room.isBooked
                                              ? " (BOOKED)"
                                              : " (AVAILABLE)"}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* Assignment Summary */}
                            <div className="alert alert-light">
                              <div className="row">
                                <div className="col-md-6">
                                  <small className="text-success">
                                    <i className="fas fa-check-circle me-1"></i>
                                    {
                                      Object.values(roomAssignments).filter(
                                        (room) => room,
                                      ).length
                                    }{" "}
                                    assigned
                                  </small>
                                </div>
                                <div className="col-md-6">
                                  <small className="text-muted">
                                    <i className="fas fa-calendar me-1"></i>
                                    Dates: {
                                      orderData?.orderDate?.split("T")[0]
                                    }{" "}
                                    to {orderData?.checkOutDate?.split("T")[0]}
                                  </small>
                                </div>
                              </div>
                            </div>

                            {/* Assign Rooms Button */}
                            <div className="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                className="btn btn-primary px-4"
                                onClick={handleAssignRooms}
                                disabled={
                                  assigningRooms ||
                                  Object.values(roomAssignments).every(
                                    (v) => !v,
                                  )
                                }
                              >
                                {assigningRooms ? (
                                  <>
                                    <i className="bx bx-loader-alt bx-spin me-2"></i>
                                    Assigning Rooms...
                                  </>
                                ) : (
                                  <>
                                    <i className="bx bx-check me-2"></i>
                                    Assign Rooms
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        )
                      ) : roomTypes.length > 0 ? (
                        <div className="alert alert-info">
                          <i className="fas fa-info-circle me-2"></i>
                          Processing guest information for room assignments...
                        </div>
                      ) : (
                        <div className="alert alert-warning">
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          No rooms found for the selected dates.
                        </div>
                      )}

                      <hr className="bg-secondary" />
                    </>
                  )}

                  <h6 class="mb-2 text-sm fw-500">Notes:</h6>
                  {selectedStatus.id !== 3 &&
                  technicianRole?.roleID === user.role_Id ? (
                    <textarea
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      onBlur={submitNotes}
                      className="form-control mb-3"
                    ></textarea>
                  ) : (
                    notes && <p className="text-sm">{notes}</p>
                  )}

                  {/* <h6 class="mb-2 text-sm fw-500">Instructions:</h6> */}
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  {/* BOOKING HISTORY */}
                  <div>
                    <h4 class="font-weight-light text-center text-muted py-3">
                      Order Activity
                    </h4>

                    {orderHistory.isSuccess &&
                      (orderHistory.data.data.length > 0 ? (
                        orderHistory.data.data.map((elem) => (
                          <>
                            <div class="row">
                              <div class="col-auto text-center flex-column d-none d-sm-flex">
                                <div class="row h-50">
                                  <div class="col ">&nbsp;</div>
                                  <div class="col">&nbsp;</div>
                                </div>
                                <h5 class="m-2">
                                  <span class="badge rounded-pill bg-light border">
                                    &nbsp;
                                  </span>
                                </h5>
                                <div class="row h-50">
                                  <div class="col  border-end order ">
                                    &nbsp;
                                  </div>
                                  <div class="col">&nbsp;</div>
                                </div>
                              </div>
                              <div class="col py-2">
                                <div class="card">
                                  <div class="card-body">
                                    <div class="float-end text-muted">
                                      {elem.createdAt &&
                                        FormatDateTime(elem.createdAt)}
                                    </div>
                                    <h4 class="card-title">{elem.name}</h4>
                                    <p>{elem.body}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ))
                      ) : (
                        <p className="text-center mt-5 mb-5 text-sm text-black-50">
                          There has been no activity so far.
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="card mb-4">
                <div className="card-body p-4">
                  <p className="text-sm mb-3">
                    <span>Order Created By</span> <br />
                    <span className="fw-600">{orderData?.createdByName}</span>
                  </p>

                  {/* TECHNICIAN Details */}
                  {/* The section will only display if statusDescription is In Progress */}
                  {Number(orderData?.statusID) === 1 && (
                    <>
                      <h6 className="mb-0 fw-500">Technician Details</h6>
                      <p class="text-sm mb-1">
                        <span>Name :</span>{" "}
                        <span class="fw-600">{orderData?.technicianName}</span>
                      </p>
                      <p class="text-sm mb-3">
                        <span>PH :</span> <span class="fw-600">7986543210</span>
                      </p>
                    </>
                  )}

                  {/* ASSIGN TECHNICIAN */}
                  {isPermissionGranted(6) &&
                    Number(orderData?.statusID) === 6 && (
                      <>
                        <span className="d-block text-sm mb-1">
                          Assign Technician
                        </span>
                        <select
                          className="form-select bg-dark text-white text-sm"
                          disabled={
                            (technicianApi.isLoading &&
                              !technicianApi.isSuccess &&
                              technicianApi.isFetching) ||
                            orderByIdApi?.data?.data[0]?.serviceTypeAndName?.some(
                              (item) =>
                                (item.typeID === 1 ||
                                  item.serviceTypeId === 1) &&
                                item.stockQuantity <
                                  item.currentBookingQuantity,
                            )
                          }
                          onChange={(e) => handleTechnician(e.target.value)}
                          value={orderData?.technicianID}
                        >
                          <option value="">Choose Technician</option>
                          {technicianApi?.data?.data?.map((technician) => (
                            <option value={technician.id} key={technician.id}>
                              {technician.name}
                            </option>
                          ))}
                        </select>
                        {orderByIdApi?.data?.data[0]?.serviceTypeAndName?.some(
                          (item) =>
                            (item.typeID === 1 || item.serviceTypeId === 1) &&
                            item.stockQuantity < item.currentBookingQuantity,
                        ) && (
                          <div class="text-xs text-danger mt-2">
                            You can't assign a technician until stock is
                            replenished.
                          </div>
                        )}
                        <hr />
                      </>
                    )}

                  <h6 className="mb-3 fw-500">Payments</h6>
                  {paymentByIdApi?.data?.data.length > 0 ? (
                    <div class="timeline timeline-one-side">
                      {paymentByIdApi?.data?.data?.map((elem) => {
                        return (
                          <div class="timeline-block mb-3">
                            <span class="timeline-step">
                              <i class="fa fa-dot-circle-o text-secondary"></i>
                            </span>
                            <div class="timeline-content">
                              <h6 class="text-dark text-sm font-weight-bold mb-0">
                                R {elem.amount.toFixed(2)}
                              </h6>
                              <p class="text-secondary text-xs mt-1 mb-0">
                                <span>{formatDate(elem.paymentDate)}</span>
                                <span class="ms-2 fw-600 text-uppercase">
                                  {elem.paymentTypeName &&
                                    `[${elem.paymentTypeName}]`}
                                </span>
                              </p>
                              <p class="text-secondary text-xs mt-1 mb-0 text-italic">
                                <span>Invoice No -</span>
                                <span class="ms-2 fw-600 text-uppercase">
                                  {elem.utrNumber}
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-sm">No Payment Made Yet !</p>
                  )}
                  {isPermissionGranted(5) && orderData?.statusID !== 4 && (
                    <div className="row">
                      <div className="col-12">
                        <button
                          type="button"
                          class="btn badge badge-success mb-3 w-100 py-3 fw-600"
                          onClick={() => setPaymentFormModal(true)}
                          disabled={
                            Number(grossTotal.toFixed(2)) ===
                            paymentByIdApi?.data?.data.reduce(
                              (sum, elem) => sum + Number(elem.amount),
                              0,
                            )
                          }
                        >
                          Add Payment
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Print Stock Requisition and Print Invoice */}
              {orderData?.statusID !== 5 && orderData?.statusID !== 4 && (
                <div class="card mb-4">
                  <div class="card-body p-4">
                    <div class="row gy-2">
                      {isPermissionGranted(8) &&
                      orderData?.statusID !== 3 &&
                      orderData?.statusID !== 8 &&
                      orderData?.statusID !== 7 &&
                      orderData?.statusID !== 9 && // Added check for status 9
                      orderData?.statusID !== 10 && // Added check for status 10
                      orderData?.adminConfirmationStatus !== 1 ? (
                        <div class="col-12">
                          <button
                            className="btn btn-icon btn-warning mb-0 w-100"
                            onClick={() =>
                              setReqStock({ ...reqStock, modal: true })
                            }
                          >
                            Request Stock
                          </button>
                        </div>
                      ) : (
                        user.role === "Technician" && (
                          <div class="col-12">
                            <p className="text-success fw-bold text-center text-sm mb-0 w-100">
                              Stock Approved
                            </p>
                          </div>
                        )
                      )}
                      {isPermissionGranted(7) && (
                        <div class="col-12">
                          <Link
                            to={`/sales-history/print-invoice?id=${orderId}`}
                            className="btn btn-icon btn-primary mb-0 w-100"
                            target="_blank"
                          >
                            Print Invoice
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* QUOTATION ACTIONS */}
              {/* {(orderData?.statusID == 5 || orderData?.statusID == 11) && (
                <div className="card mb-4 quotation-actions-card">
                  <div className="card-header bg-gradient-primary text-white py-3">
                    <h6 className="mb-0 text-white fw-600">
                      <i className="fas fa-file-alt me-2"></i>Quotation Actions
                    </h6>
                  </div>
                  <div className="card-body p-4">
            
                    <div className="mb-3">
                      <Link
                        to={`/sales-history/print-quotation?id=${orderId}`}
                        className="btn btn-warning btn-lg w-100 d-flex align-items-center justify-content-center quotation-print-btn"
                        target="_blank"
                      >
                        <PiPrinterLight
                          size={16}
                          style={{ marginRight: "5px" }}
                        />
                        Print Quotation
                      </Link>
                    </div>
       
                    <div className="row g-2">
                      {isPermissionGranted(3) && (
                        <div className="10">
                          <button
                            type="button"
                            className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center quotation-edit-btn"
                            onClick={() => setEditQuotationModal(true)}
                          >
                            <RiEdit2Fill
                              size={16}
                              style={{ marginRight: "5px" }}
                            />
                            Edit
                          </button>
                        </div>
                      )}
                    </div>

                  
                    <div className="mt-3">
                      <div className="quotation-info-text">
                        <small className="text-muted d-flex align-items-center">
                          <BsInfoCircle
                            size={16}
                            style={{ marginRight: "5px" }}
                          />
                          You can print, edit, or cancel this quotation based on
                          your permissions.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              {/* Cancelled Order Credit Note */}
              {orderData?.statusID == 4 && (
                <div class="card mb-4">
                  <div class="card-body p-4">
                    <div class="row gy-2">
                      {/* {
                                                        isPermissionGranted(3) && (
                                                            <div class="col-12">
                                                                <button type="button" class="btn btn-icon btn-danger mb-0 w-100" onClick={()=>setStatusChangeConfirmationModal({description:'confirmed', id: '6'})}>
                                                                    Confirm Order
                                                                </button>
                                                            </div>
                                                        )
                                                    } */}
                      {/* <div class="col-12 ">
                        <Link
                          to={`/sales-history/print-credit-note?id=${orderId}`}
                          className="btn btn-icon btn-danger mb-0 w-100"
                          target="_blank"
                          style={{ backgroundColor: "rgb(223, 48, 48)" }}
                        >
                          Print Credit Note
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              )}

              {/* VEHICLE DETAILS */}
              {orderData?.technicianID == user.id && (
                <div class="card mb-4">
                  <div class="card-body p-4">
                    <div class="row gy-2">
                      {isPermissionGranted(9) && (
                        <div class="col-12">
                          <Link
                            to={`/sales-history/print-jobcard?id=${orderId}`}
                            className="btn btn-icon btn-success mb-0 w-100"
                            target="_blank"
                          >
                            Print Job Card
                          </Link>
                        </div>
                      )}
                      {isPermissionGranted(10) && (
                        <div class="col-12">
                          <button
                            type="button"
                            className="btn btn-icon btn-danger mb-0 w-100"
                            onClick={() =>
                              setVehicleModal(
                                orderByIdApi?.data?.data[0].orderId,
                              )
                            }
                          >
                            Vehicle Details
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
      {/* SELECT ADMIN TO REQUEST NEW STOCK POPUP */}
      <Modal
        show={reqStock.modal}
        onHide={() => setReqStock({ ...reqStock, modal: false })}
        size="sm"
        centered
      >
        <Modal.Body className="text-center p-4">
          <h5>Select an admin to request stocks</h5>

          <select
            disabled={!userList.isSuccess}
            value={reqStock.adminId}
            onChange={(e) =>
              setReqStock({ ...reqStock, adminId: e.target.value })
            }
            className="form-select mb-3"
          >
            <option value="">Select</option>
            {userList?.data?.data.map((elem, i) => {
              return <option value={elem.id}>{elem.username}</option>;
            })}
          </select>

          <div className="buttons d-flex gap-3 justify-content-center">
            <button
              className="btn btn-danger bg-danger btn-sm mb-0"
              onClick={() => setReqStock({ ...reqStock, modal: false })}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm mb-0"
              onClick={requestStock}
              disabled={!reqStock.adminId}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* STATUS CHANGE MODAL */}
      <Modal
        show={statusChangeConfirmationModal}
        onHide={() => setStatusChangeConfirmationModal(false)}
        size="sm"
        centered
      >
        <Modal.Body className="text-center p-4">
          <h5>
            Are you sure you want to change the status to{" "}
            {statusChangeConfirmationModal &&
              statusChangeConfirmationModal.description && (
                <span className="fw-600 text-primary">
                  {statusChangeConfirmationModal.description}
                </span>
              )}{" "}
            ?
          </h5>
          <p className="text-sm mb-4">
            This action will update the current status and may impact ongoing
            processes. Please confirm to proceed.
          </p>

          {/* Show off day information if available */}
          {offDayData && offDayData.summary && (
            <div className="alert alert-info mb-3 text-start">
              <h6 className="mb-2">Off Days Summary:</h6>
              <div className="row">
                <div className="col-4 text-center">
                  <div className="h6 text-success mb-1">
                    {offDayData.summary.usedDays}
                  </div>
                  <small>Used Days</small>
                </div>
                <div className="col-4 text-center">
                  <div className="h6 text-danger mb-1">
                    {offDayData.summary.offDays}
                  </div>
                  <small>Off Days</small>
                </div>
                <div className="col-4 text-center">
                  <div className="h6 text-primary mb-1">
                    {offDayData.summary.totalDays}
                  </div>
                  <small>Total Days</small>
                </div>
              </div>
              {offDayData.offDays && offDayData.offDays.length > 0 && (
                <div className="mt-2">
                  <small>
                    <strong>Off Day Dates:</strong>{" "}
                    {offDayData.offDays.join(", ")}
                  </small>
                </div>
              )}
            </div>
          )}

          <div className="buttons d-flex gap-3 justify-content-center">
            <button
              className="btn btn-danger bg-danger btn-sm mb-0"
              onClick={() => setStatusChangeConfirmationModal(false)}
              disabled={
                updateStatusLoading ||
                processOffDaysLoading ||
                updateStatusWithOffDaysLoading
              }
            >
              <i className="fas fa-times me-2"></i>
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm mb-0"
              onClick={handleStatusChange}
              disabled={
                updateStatusLoading ||
                processOffDaysLoading ||
                updateStatusWithOffDaysLoading
              }
            >
              {updateStatusLoading ||
              processOffDaysLoading ||
              updateStatusWithOffDaysLoading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    style={{ width: "1rem", height: "1rem" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  Processing...
                </>
              ) : (
                <>
                  <i className="fas fa-check me-2"></i>
                  Confirm
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* PAYMENT FORM MODAL */}
      <Modal
        show={paymentFormModal}
        onHide={() => setPaymentFormModal(false)}
        size="lg"
        centered
      >
        <Modal.Body>
          <h4 className="mb-4 fs-5">Payment Details</h4>
          <AddPaymentForm
            handleSubmit={handleAddPayment}
            totalAmount={orderData?.subTotal}
            setPaymentFormModal={setPaymentFormModal}
            data={{
              discountType: orderData?.discountType,
              discount: orderData?.discount,
              paidAmount: orderData?.amountPaid,
              paymentType: paymentByIdApi?.data?.data[0].paymentType,
              utrNumber: paymentByIdApi?.data?.data[0].utrNumber,
              notes: paymentByIdApi?.data?.data[0].notes,
              specialInstruction: "",
              orderId: orderId,
              paidAmount: paymentByIdApi?.data?.data.reduce(
                (acc, payment) => acc + payment.amount,
                0,
              ),
            }}
          />
        </Modal.Body>
      </Modal>
      {/* Vehicle Details Modal */}
      <Modal
        show={vehicleModal}
        onHide={() => setVehicleModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <h5 className="mb-0">{"Vehicle Details"}</h5>
        </Modal.Header>
        <Modal.Body className="p-4">
          <AddEditVehicleDetails
            orderId={orderId}
            data={vehicleByOrderIdApi?.data?.data[0] || {}}
            orderStatusId={selectedStatus.id}
            onSubmit={handleVehicleDetailsSubmit}
          />
        </Modal.Body>
      </Modal>
      {/* ADD REQUISITION MODAL */}
      <Modal show={reqMdl} onHide={() => setReqMdl(false)} size="sm" centered>
        <Modal.Body className="p-4">
          <h5>Add Requisition</h5>
          <div className="row gy-2">
            <div className="col-md-12">
              <label>Requisition Date</label>
              <input
                type="date"
                className="form-control"
                name="requisitionDate"
                value={reqForm.requisitionDate}
                onChange={(e) => {
                  setReqForm({ ...reqForm, [e.target.name]: e.target.value });
                  setErrors({ ...errors, requisitionDate: "" });
                }}
                required
                disabled
              />
              {errors.requisitionDate && (
                <small className="text-danger">{errors.requisitionDate}</small>
              )}
            </div>
            <div className="col-md-12">
              <label>Requisition Note</label>
              <textarea
                className="form-control"
                name="requisitionNote"
                value={reqForm.requisitionNote}
                onChange={(e) => {
                  setReqForm({ ...reqForm, [e.target.name]: e.target.value });
                  setErrors({ ...errors, requisitionNote: "" });
                }}
                required
              />
              {errors.requisitionNote && (
                <small className="text-danger">{errors.requisitionNote}</small>
              )}
            </div>
          </div>
          <div className="buttons d-flex gap-3 justify-content-center mt-4">
            <button
              className="btn btn-danger bg-danger btn-sm mb-0"
              onClick={() => setReqMdl(false)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm mb-0"
              onClick={handleCreateReq}
              disabled={!reqForm.requisitionDate || !reqForm.requisitionNote}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* OFF DAY MODAL */}
      <CalendarModal
        show={offDayModal}
        onHide={handleOffDayCancel}
        onConfirm={handleOffDayConfirm}
        statusData={{
          ...pendingStatusChange,
          userId: user?.id, // ✅ Add user ID to statusData
          orderId: orderId, // ✅ Add order ID to statusData
        }}
        title="Mark Off Days - Checkout Preparation"
        bookingStartDate={orderData?.orderDate || orderData?.checkInDate}
        bookingEndDate={orderData?.checkOutDate}
        initialOffDays={orderData?.existingOffDays || []}
        existingOffDaysData={existingOffDaysData} // Pass existing off-days from API
        reservationData={orderData}
        showPricing={true}
        isProcessing={processOffDaysLoading || updateStatusWithOffDaysLoading}
        processingMessage={
          processOffDaysLoading
            ? "Processing off-days selection..."
            : updateStatusWithOffDaysLoading
              ? "Updating order status..."
              : "Processing..."
        }
        // New props for two-step process
        showCompletionOptions={offDayProcessingComplete}
        onProceedToCheckout={handleProceedToCheckout}
        onCompleteClose={handleOffDayCompleteClose}
        pendingStatusDescription={pendingStatusChange?.description}
        isUpdatingStatus={updateStatusLoading}
      />
      {/* EDIT QUOTATION MODAL */}
      {editQuotationModal && (
        <Modal
          show={editQuotationModal}
          onHide={() => setEditQuotationModal(false)}
          size="xl"
          centered
          dialogClassName="custom-modal-width"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Modal.Header closeButton>
            <h5 className="mb-0">Edit Quotation</h5>
          </Modal.Header>
          <Modal.Body
            className="p-0"
            style={{ maxHeight: "85vh", overflowY: "auto" }}
          >
            <EditQuotationForm
              orderData={orderData}
              onSubmit={handleEditQuotation}
              onCancel={() => setEditQuotationModal(false)}
              companyID={orderData?.companyID}
              onItemDeleted={() => orderByIdApi.refetch()}
            />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default SalesDetails;
